<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import Cproduct from '~/components/product/Cproduct.vue';
import CrossSell from '~/components/sliders/CrossSell.vue';
import Prices from '~/components/product/Prices.vue';
import { useProductStore } from '~/store/product/productStore';
import { useVariantSelectorStore } from '~/store/variantSelectorStore';
import { MODAL_CART } from '~/store/modalStore';
const productStore = useProductStore();
const variantSelectorStore = useVariantSelectorStore();

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)

const {
  currentVariant
} = storeToRefs(variantSelectorStore)

const {
  product,
  images,
  wasOffer
} = storeToRefs(productStore)
</script>

<template>
  <div>
    <modal
           :id="MODAL_CART"
           :is-visible="isModalVisible"
           :title="$t('www.product.add_product_basket')"
           @close="closeModal">
      <div class="cart-recap">
        <div class="cart-recap__product">
          <div class="cart-product">
            <div class="df">
              <div class="image__container--product image image--radius">
                <div
                    style="width: 130px"
                    class="image--radius image--product">
                  <picture>
                    <source type="image/avif" :srcset="images[0].imageAVIF" >
                    <source type="image/webp" :srcset="images[0].imageWEBP" >
                    <source type="image/jpeg" :srcset="images[0].imageJPG" >
                    <img :src="images[0].imageJPG" alt="" >
                  </picture>
                </div>
              </div>
            </div>
            <div class="cart-product__details">
              <div class="df">
                <div class="df fdc">
                  <div>
                    <div class="cart-product__brand">
                      {{ product.brand.name }}
                    </div>
                    <a
                       class="cart-product__name"
                       data-tclz-selector="cart-product"
                       data-tclz-label="url"
                       data-tclz-category="product"
                       href="url">
                      {{ product.nameWithoutBrand }}
                    </a>
                    <div v-if="currentVariant?.variant.displayName !== ''" class="cart-product__color-size">
                      <div class="cart-product__cara mr-h">{{ $t('www.account.orders.size') }}</div>
                      <div class="cart-product__cara-value" data-cart-recap-criterion-value>{{ currentVariant?.variant.value }}</div>
                    </div>
                    <div class="cart-product__color-size">
                      <span class="cart-product__cara mr-h">{{ $t('www.account.orders.product_qt') }}</span>
                      <span class="cart-product__cara-value">1</span>
                    </div>
                  </div>
                  <div class="cart-product__price">
                    <prices :price-dto="currentVariant?.price" :was-offer="wasOffer" :is-small="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-recap__action">
          <div class="cart-recap__btn">
            <a
id="stop-shopping"
               :href="($customLocalePath as any)('www_cart')"
               class="cbtn cbtn--large cbtn--large-input cbtn--dark"
               data-button-loader
               data-tclz-selector="go-to-cart"
               data-tclz-label=""
               data-tclz-category="product">
              {{ $t('www.product.see_basket') }}
            </a>
          </div>
          <div class="cart-recap__btn mt-1">
            <button
type="button"
                    class="cbtn cbtn--medium cbtn--dark--inverted"
                    data-tclz-selector="continue-shopping"
                    data-tclz-label=""
                    data-tclz-category="product"
                    data-modal-close="modal-shopping"
                    @click="closeModal">
              {{ $t('www.product.continue_purchase') }}</button>
          </div>
        </div>
      </div>
      <div class="hidden-mobile cart-recap__grey-border"/>
      <div
          v-for="(crossSell, index) in product.crossSellCollection"
          :key="index">
        <cross-sell
            v-if="crossSell && crossSell.position === 4"
            :title="crossSell.trackingInfos.title"
            :cross-sell-items="crossSell.crossSellItems"
        >
          <div v-for="item in crossSell.crossSellItems" :key="item.id" class="carousel-v2-item">
            <cproduct
                :price-dto="item.priceDTO"
                :product-id="item.id"
                :sport="product.sport"
                :main-image-image-jpg2x="item.mainImage.imageJPG2X"
                :brand-name="item.brand.name"
                :main-image-context="item.mainImage.context"
                :main-image-image-webp2x="item.mainImage.imageWEBP2X"
                :without-retina="true"
                :global-rate-count="0"
                :name-without-brand="item.nameWithoutBrand"
                :set-as-title="false"
                :hide-label="false"
                :global-rate="item.productReviewDTO.globalRate"/>
          </div>
        </cross-sell>
      </div>
    </modal>
  </div>
</template>
